export default [
  {
    label: 'Explore',
    url: '/explore/',
  },
  {
    label: 'Must Reads',
    url: '/explore/must-reads',
  },
  {
    label: 'Trending',
    url: '/explore/trending',
  },
  {
    label: 'Tech',
    url: '/explore/technology',
  },
  {
    label: 'Finance',
    url: '/explore/finance',
  },
  {
    label: 'Health',
    url: '/explore/health',
  },
  {
    label: 'Travel',
    url: '/explore/travel',
  },
];

export const myList = {
  label: 'My List',
  url: '/'
}

